import { memo, useLayoutEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import enRoles from 'src/models/enums/enRoles';

interface IProps {
  passIfNull?: boolean;
  roles?: enRoles | enRoles[];
  inverse?: boolean;
  children?: JSX.Element;
}

const PermissionHide = memo<IProps>(props => {
  const { roles } = props;
  const [canAccess, setCanAccess] = useState<boolean>(false);
  const { user } = useAuth();

  useLayoutEffect(() => {
    if (user) {
      const _roles = Array.isArray(roles) ? roles : (roles ? [roles] : []);
      const can = _roles.some(r => user.roles.includes(r)) || user.roles.includes(enRoles.sysAdmin)
      setCanAccess(can);
    }
  }, [roles, user]);

  if (props.inverse && !canAccess) {
    return props.children as any;
  }

  if (props.inverse || !canAccess) {
    return null;
  }

  return props.children as any;
});

export default PermissionHide;
